import React, { useState, useEffect } from 'react'
import { useTranslation } from '~/hooks/useTranslation'
import { Button } from '~/lib/ui/button'
import { getApi } from '~/util/api'
import { Card, Typography } from '~/components/_atoms'
import Spinner from '~/components/shared/Spinner'
import { ChatBubble } from 'iconoir-react'

export function CoachSupportCard({ className, programLevel }) {
  const { t } = useTranslation()
  const [isLoading, setIsLoading] = useState(false)
  const [coachInfo, setCoachInfo] = useState(null)
  const coachChatImage =
    'https://www-yns-com.s3.amazonaws.com/images/coach_chat/coach-chat-banner.png'
  const isSoloPlus = programLevel ? programLevel === 'solo_plus' : false

  useEffect(() => {
    setIsLoading(true)
    getApi()
      .get('/coach_info')
      .then((response) => {
        if (response.status == 200) {
          setCoachInfo(response.data)
          return
        } else {
          throw new Error('json request failed')
        }
      })
      .finally(() => {
        setIsLoading(false)
      })
      .catch((error) => {
        console.log('json request failed', error)
      })
  }, [setCoachInfo])

  return (
    <Card
      className={className}
      color="secondary"
      title={
        isSoloPlus
          ? t('coach_support_card.immediate_support')
          : t('coach_support_card.title')
      }
      titleColor="secondary"
      icon={<ChatBubble className="h-10 w-10 stroke-intoo-green-coachcta" />}
      actions={
        <Button
          variant="coachcta"
          className="open-chat-modal w-full"
          data-toggle="modal"
          data-target="#coach_chat_list"
          data-action={t('coach_support_card.view_action')}
        >
          {t('coach_support_card.view_action')}
        </Button>
      }
    >
      {isLoading ? (
        <div className="flex h-full items-center justify-center">
          <Spinner show className="h-9 w-9" />
        </div>
      ) : (
        <>
          <div className="flex h-full flex-col items-center justify-center">
            <img
              className="h-45 w-45 "
              src={coachChatImage}
              alt="Live Coach Chat Image"
            />
            {coachInfo?.time_since_last_check_in && (
              <Typography variant="small">
                {coachInfo?.time_since_last_check_in}
              </Typography>
            )}
          </div>
        </>
      )}
    </Card>
  )
}
